import { get } from '@/libs/http';
import { createApiQuery } from '@/hooks/use-api-query';
import { GameByTypeIdReq, GameByTypeIdRes } from '@/types/api/hall/casino/game-by-type-id.d';

export const getCasinoGameDetail = (params: GameByTypeIdReq) => {
  return get<GameByTypeIdRes>('/hall/casino/v1/game/by-type-id', { params });
};

export const useGetCasinoGameDetail = createApiQuery(getCasinoGameDetail, (params) => [params.game_type, params.game_id]);